export default __webpack_public_path__ + "static/media/rack8.6a7708cb.webp";